/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "kde": {
        "nu": ["latn"],
        "year": {
          "0": "this year",
          "1": "next year",
          "future": {
            "other": "+{0} y"
          },
          "past": {
            "other": "-{0} y"
          },
          "-1": "last year"
        },
        "year-short": {
          "0": "this year",
          "1": "next year",
          "future": {
            "other": "+{0} y"
          },
          "past": {
            "other": "-{0} y"
          },
          "-1": "last year"
        },
        "year-narrow": {
          "0": "this year",
          "1": "next year",
          "future": {
            "other": "+{0} y"
          },
          "past": {
            "other": "-{0} y"
          },
          "-1": "last year"
        },
        "quarter": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "last quarter"
        },
        "quarter-short": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "last quarter"
        },
        "quarter-narrow": {
          "0": "this quarter",
          "1": "next quarter",
          "future": {
            "other": "+{0} Q"
          },
          "past": {
            "other": "-{0} Q"
          },
          "-1": "last quarter"
        },
        "month": {
          "0": "this month",
          "1": "next month",
          "future": {
            "other": "+{0} m"
          },
          "past": {
            "other": "-{0} m"
          },
          "-1": "last month"
        },
        "month-short": {
          "0": "this month",
          "1": "next month",
          "future": {
            "other": "+{0} m"
          },
          "past": {
            "other": "-{0} m"
          },
          "-1": "last month"
        },
        "month-narrow": {
          "0": "this month",
          "1": "next month",
          "future": {
            "other": "+{0} m"
          },
          "past": {
            "other": "-{0} m"
          },
          "-1": "last month"
        },
        "week": {
          "0": "this week",
          "1": "next week",
          "future": {
            "other": "+{0} w"
          },
          "past": {
            "other": "-{0} w"
          },
          "-1": "last week"
        },
        "week-short": {
          "0": "this week",
          "1": "next week",
          "future": {
            "other": "+{0} w"
          },
          "past": {
            "other": "-{0} w"
          },
          "-1": "last week"
        },
        "week-narrow": {
          "0": "this week",
          "1": "next week",
          "future": {
            "other": "+{0} w"
          },
          "past": {
            "other": "-{0} w"
          },
          "-1": "last week"
        },
        "day": {
          "0": "Nelo",
          "1": "Nundu",
          "future": {
            "other": "+{0} d"
          },
          "past": {
            "other": "-{0} d"
          },
          "-1": "Lido"
        },
        "day-short": {
          "0": "Nelo",
          "1": "Nundu",
          "future": {
            "other": "+{0} d"
          },
          "past": {
            "other": "-{0} d"
          },
          "-1": "Lido"
        },
        "day-narrow": {
          "0": "Nelo",
          "1": "Nundu",
          "future": {
            "other": "+{0} d"
          },
          "past": {
            "other": "-{0} d"
          },
          "-1": "Lido"
        },
        "hour": {
          "0": "this hour",
          "future": {
            "other": "+{0} h"
          },
          "past": {
            "other": "-{0} h"
          }
        },
        "hour-short": {
          "0": "this hour",
          "future": {
            "other": "+{0} h"
          },
          "past": {
            "other": "-{0} h"
          }
        },
        "hour-narrow": {
          "0": "this hour",
          "future": {
            "other": "+{0} h"
          },
          "past": {
            "other": "-{0} h"
          }
        },
        "minute": {
          "0": "this minute",
          "future": {
            "other": "+{0} min"
          },
          "past": {
            "other": "-{0} min"
          }
        },
        "minute-short": {
          "0": "this minute",
          "future": {
            "other": "+{0} min"
          },
          "past": {
            "other": "-{0} min"
          }
        },
        "minute-narrow": {
          "0": "this minute",
          "future": {
            "other": "+{0} min"
          },
          "past": {
            "other": "-{0} min"
          }
        },
        "second": {
          "0": "now",
          "future": {
            "other": "+{0} s"
          },
          "past": {
            "other": "-{0} s"
          }
        },
        "second-short": {
          "0": "now",
          "future": {
            "other": "+{0} s"
          },
          "past": {
            "other": "-{0} s"
          }
        },
        "second-narrow": {
          "0": "now",
          "future": {
            "other": "+{0} s"
          },
          "past": {
            "other": "-{0} s"
          }
        }
      }
    },
    "availableLocales": ["kde"],
    "aliases": {},
    "parentLocales": {}
  });
}